<template>
  <label class="input-range">
    <input
      class="input-range__input"
      type="range"
      :value="value"
      :name="name"
      :min="options.min"
      :max="options.max"
      @input="changeHandler"
    >
  </label>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        min: 0,
        max: 10,
        current: 5,
      }),
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
  },
  emits: ['change'],
  setup(props, context) {
    const changeHandler = function (e) {
      context.emit('change', {
        type: props.name,
        value: Number(e.target.value),
      });
    };

    return {
      changeHandler,
    };
  },
};
</script>

<style lang="scss">
.input-range {
  $this: 'input-range';

  &__input {
    width: 100%;
  }
}
</style>
